<script>
import u from '@/utils'

export default {
  props: {
    value: {
      type: Object,
      default: function() {
        return {}
      }
    },

    checked: {
      type: Array,
      default: function() {
        return []
      }
    },

    items: {
      type: Array,
      default: function() {
        return []
      }
    },

    checkbox: {
      type: Boolean,
      default: false
    },

    mini: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      query: '',
      active: this.value ? [this.value.hexId] : [],
      checkedItemIds: this.checked
    }
  },

  computed: {
    selected() {
      let item = null
      if (this.active.length !== 0 && this.active[0]) {
        const hexId = this.active[0]
        item = this.findInTree(this.items, hexId)
      }
      this.$emit('input', item)
      return item
    }
  },

  watch: {
    value() {
      this.active = this.value ? [this.value.hexId] : []
    },
    checkedItemIds() {
      this.checkbox && this.$emit('update:checked', this.checkedItemIds)
    }
  },

  created() {
  },

  methods: {
    findInTree(items, hexId) {
      let item = items.find(item => item.hexId === hexId)
      if (item) {
        return item
      } else {
        let children = items
          .filter(item => item.children && item.children.length)
          .map(item => item.children)
          .flat()
        return this.findInTree(children, hexId)
      }
    }
  }
}
</script>
<template>
  <v-card>
    <v-card-title>
      <v-list-tile-avatar>
        <v-icon>search</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          <v-text-field color="secondary" label="Search" v-model="query" xs5>
          </v-text-field>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="query = ''">
          <v-icon>clear</v-icon>
        </v-btn>
        <span>Clear search</span>
      </v-tooltip>
    </v-card-title>
    <v-layout class="pa-2">
      <v-flex xs4 v-if="mini">
        <v-scroll-y-transition mode="out-in">
          <div
            v-if="!selected"
            class="title grey--text text--lighten-1 font-weight- pa-2"
            style="align-self: center;"
          >
            Select Profile
          </div>
          <v-card
            v-else
            :key="selected.id"
            class="mx-auto"
            flat
            max-width="800"
          >
            <v-card-text>
              <v-avatar size="88">
                <vue-letter-avatar
                  :name="selected.name"
                  size="40"
                  :rounded="true"
                />
              </v-avatar>
              <h3 class="headline mb-2">
                {{ selected.name }}
              </h3>
            </v-card-text>
          </v-card>
        </v-scroll-y-transition>
      </v-flex>
      <v-flex
        :xs4="!mini && selected !== null"
        :xs8="mini"
        :xs12="!mini && selected === null"
        style="overflow-x: auto; padding-left:20px"
      >
        <v-treeview
          :active.sync="active"
          :items="items"
          :search="query"
          activatable
          active-class="secondary--text"
          transition
          open-all
          :selectable="checkbox"
          item-key="hexId"
          item-text="name"
          v-model="checkedItemIds"
        >
          <template v-if="!item.children" slot="prepend" slot-scope="{ item }">
            <v-icon>account_circle</v-icon>
          </template>
          <template slot="label" slot-scope="{ item }">
            <div style="cursor:pointer;" class="text-xs-left">
              {{ item.name }}
            </div>
          </template>
        </v-treeview>
      </v-flex>
      <v-flex xs8 v-if="!mini && selected !== null" class="pa-2">
        <slot name="picker-item-detail" :item="selected">
          <div>Please pass a detail view component to render here. Thanks.</div>
        </slot>
      </v-flex>
    </v-layout>
  </v-card>
</template>
